import { LinkItem } from './types'
import includes from 'lodash/includes'
import startsWith from 'lodash/startsWith'
import { ToggleButtonOption } from '../InputToggleButton/types'
import findIndex from 'lodash/findIndex'

const LETTERS_0_9 = '0-9'

export const letterOptions = (alphabet: string) => {
    const options: ToggleButtonOption[] = []
    for (let i = 0; i < alphabet.length; i++) {
        options.push({ label: alphabet.charAt(i), value: alphabet.charAt(i) })
    }
    options.push({ label: LETTERS_0_9, value: LETTERS_0_9 })
    return options
}

export const getFirstValidLetter = (linkName: string) => {
    const firstLetterIndex = findIndex(linkName, (char: string) => {
        const index = char.search(/[A-Za-zåäöÅÄÖ]/)
        return index >= 0
    })
    let firstLetter = ''
    if (firstLetterIndex >= 0) {
        // Link name has letters a-ö, first one counts
        firstLetter = linkName.charAt(firstLetterIndex)
    } else {
        // No letters a-ö was found, check for a beginning number
        firstLetter = linkName.charAt(0)
        const numericIndex = firstLetter.search(/[0-9]/)
        if (numericIndex !== -1) {
            firstLetter = LETTERS_0_9
        }
    }
    return firstLetter
}

export const linksForLetter = (links: LinkItem[], letter: string) => {
    if (!letter) {
        return []
    }
    return links.filter(link => {
        const linkName = link.name || ''
        const firstLetter = getFirstValidLetter(linkName)
        return startsWith(firstLetter.toLowerCase(), letter.toLowerCase())
    })
}
